// extracted by mini-css-extract-plugin
module.exports = {"tabItem":"tab-menu-item_tabItem__v_LLQ","tabItem--active":"tab-menu-item_tabItem--active__t45N3","counter":"tab-menu-item_counter__Ssqgm"};